import type { ErrorInfo, ReactNode } from 'react';
import { Component } from 'react';

import { webObservability } from '../lib/observability';
import { AppErrorScreen } from './AppErrorScreen';

interface AppErrorBoundaryProps {
  children: ReactNode;
}

interface AppErrorBoundaryState {
  error: Error | null;
}

export class AppErrorBoundary extends Component<
  AppErrorBoundaryProps,
  AppErrorBoundaryState
> {
  state: AppErrorBoundaryState = {
    error: null,
  };

  static getDerivedStateFromError(error: Error): AppErrorBoundaryState {
    return {
      error,
    };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    webObservability.captureException(error, {
      extra: {
        errorInfo,
      },
      tags: {
        operation: 'react.render',
        section: 'app',
      },
    });
  }

  render() {
    if (this.state.error !== null) {
      return (
        <AppErrorScreen error={this.state.error} reset={this.handleReset} />
      );
    }

    return this.props.children;
  }

  private handleReset = () => {
    this.setState({
      error: null,
    });
  };
}
